import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';

export const PAUSE = 1200;

type State = {
  hoveredToastsCount: number;
  isPauseActive: boolean;
  resumeTimeoutId: number | null;
};

export const useNotificationTimerStore = defineStore(StoreId.NotificationTimer, {
  state: (): State => ({
    hoveredToastsCount: 0,
    isPauseActive: false,
    resumeTimeoutId: null,
  }),
  getters: {
    isTimerPaused: (state): boolean => state.hoveredToastsCount > 0 || state.isPauseActive,
  },
  actions: {
    hoverEnter(): void {
      if (this.resumeTimeoutId !== null) {
        clearTimeout(this.resumeTimeoutId);
        this.resumeTimeoutId = null;
      }

      this.isPauseActive = false;
      this.hoveredToastsCount += 1;
    },
    hoverLeave(withDelay = true): void {
      if (this.hoveredToastsCount === 0) {
        return;
      }

      this.hoveredToastsCount = Math.max(0, this.hoveredToastsCount - 1);

      if (this.hoveredToastsCount === 0 && withDelay) {
        if (this.resumeTimeoutId !== null) {
          clearTimeout(this.resumeTimeoutId);
        }

        this.isPauseActive = true;
        this.resumeTimeoutId = window.setTimeout(() => {
          this.isPauseActive = false;
          this.resumeTimeoutId = null;
        }, PAUSE);
      }
    },
  },
});
